import { MoreOutlined } from "@ant-design/icons";
import { Divider, Dropdown, Flex, Form, FormListFieldData } from "antd";
import { FC, ReactNode } from "react";
import { normalizeDecimalInput } from "tm-shared/utils";

import { PrimaryText } from "@/shared/ui/Typography";

import { StyledInputNumber } from "../../Styled";
import { StyledMenuButton } from "./Styled";

interface ContractDiscountRowProps {
    productName: string;
    field: FormListFieldData;
    menuItems: {
        key: string;
        label: ReactNode;
    }[];
    remove: (index: number) => void;
}

export const ContractDiscountRow: FC<ContractDiscountRowProps> = ({
    field,
    menuItems,
    productName,
    remove,
}) => {
    return (
        <Flex key={field.key} vertical gap={12}>
            <Form.Item name={[field.name, "barcode"]} hidden>
                <input />
            </Form.Item>

            <Flex justify="space-between" align="flex-start" gap={4}>
                <Flex flex={1} vertical gap={4}>
                    <Flex justify="space-between" align="center" gap={8}>
                        <PrimaryText>{productName}</PrimaryText>
                    </Flex>

                    <Flex justify="space-between" align="center" gap={8}>
                        <PrimaryText>Очікувана вартість:</PrimaryText>

                        <Form.Item
                            name={[field.name, "price"]}
                            style={{ marginBottom: 0 }}
                            rules={[{ required: true, message: "" }]}
                        >
                            <StyledInputNumber
                                min={0}
                                parser={normalizeDecimalInput}
                                style={{ width: 70 }}
                            />
                        </Form.Item>
                    </Flex>
                </Flex>

                <Dropdown
                    menu={{
                        items: menuItems,
                        onClick: () => remove(field.name),
                    }}
                >
                    <StyledMenuButton type="text" icon={<MoreOutlined />} />
                </Dropdown>
            </Flex>

            <Divider style={{ margin: 0 }} />
        </Flex>
    );
};
